import { useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function OrderingBlockedModal({ open, block, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open || !block) return null;

  return createPortal(
    <div className="rdp-block-modal-backdrop" role="presentation" onMouseDown={onClose}>
      <div
        className="rdp-block-modal"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="rdp-block-modal-title"
        aria-describedby="rdp-block-modal-desc"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="rdp-block-modal__head">
          <h2 id="rdp-block-modal-title" className="rdp-block-modal__title">
            {block.title}
          </h2>
          <button type="button" className="rdp-block-modal__close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <p id="rdp-block-modal-desc" className="rdp-block-modal__message">
          {block.message}
        </p>
        <div className="rdp-block-modal__actions">
          <button type="button" className="rdp-block-modal__btn" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
